/* istanbul ignore file */
import { getGlobalConfig } from '@/utils/globalConfig'
import { datadogRum } from '@datadog/browser-rum'

export function initRUM () {
  if (getGlobalConfig('Datadog.RUM.enabled') === true) {
    try {
      datadogRum.init({
        applicationId: getGlobalConfig('Datadog.RUM.applicationId'),
        clientToken: getGlobalConfig('Datadog.RUM.clientToken'),
        env: getGlobalConfig('Datadog.RUM.env'),
        site: getGlobalConfig('Datadog.RUM.site'),
        service: 'epayment-portal',
        version: getGlobalConfig('Datadog.RUM.version', '1.0.0'),
        ...getGlobalConfig('Datadog.RUM.options', {})
      })

      console.info('Using Datadog RUM')
    } catch (error) {
      console.error('Unable to init Datadog RUM')
    }
  }
}
